import React from 'react'
import * as colors from '../../assets/js/colors'

import './TextBtn.css'
export default function TextBtn({
  children,
  onClick,
  color,
  fontSize = '0.8rem',
  disabled = false,
}) {
  const style = {
    color: disabled ? '#9e9e9e' : color ? color : colors.azul,
    fontSize,
  }
  return (
    <button className="TextBtn" style={style} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  )
}
